import React from 'react'
import * as R from 'ramda'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const OutcomeDescription = ({ outcomes }) => (
  <React.Fragment>
    {R.map(
      key => (
        <DetailsCard.Text {...{ key }}>{key}</DetailsCard.Text>
      ),
      outcomes,
    )}
  </React.Fragment>
)
